import FloorPlanViewerCanvas from './Canvas';
import FloorPlanViewerFooter from './Footer';

const FloorPlanViewer = {
  Footer: FloorPlanViewerFooter,
  Canvas: FloorPlanViewerCanvas,
};

export default FloorPlanViewer;
